import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import InsuranceListing from "./InsuranceListing";

function Insurance() {
  return (
    <DashboardLayout>
      <InsuranceListing />
    </DashboardLayout>
  );
}

export default Insurance;
